<template>
    <v-container fluid>
        <v-row class="align-center mb-2">
            <v-col cols="auto">
                <h2 class="text-h6">Aziende</h2>
            </v-col>
            <v-spacer />
            <v-col cols="auto">
                <v-btn color="primary" prepend-icon="mdi-plus" @click="apriDialog(null)">Nuova azienda</v-btn>
            </v-col>
        </v-row>

        <v-data-table :headers="headers" :items="lista" :items-per-page="15" density="comfortable">
            <template #[`item.ragioneSociale`]="{ item }">
                <a href="#" class="text-primary" @click.prevent="vaiDettaglio(item.id)">{{ item.ragioneSociale }}</a>
            </template>
            <template #[`item.haUtente`]="{ item }">
                <v-chip size="small" :color="item.haUtente ? 'success' : 'grey'" variant="flat">
                    {{ item.haUtente ? 'Presente' : 'Da creare' }}
                </v-chip>
            </template>
            <template #[`item.attivo`]="{ item }">
                <v-chip size="small" :color="item.attivo ? 'success' : 'grey'" variant="flat">
                    {{ item.attivo ? 'Attiva' : 'Disattivata' }}
                </v-chip>
            </template>
            <template #[`item.azioni`]="{ item }">
                <v-btn icon variant="text" size="small" @click="apriDialog(item)" title="Modifica">
                    <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-btn v-if="item.attivo" icon variant="text" size="small" color="error" @click="disattiva(item)"
                    title="Disattiva azienda">
                    <v-icon>mdi-lock</v-icon>
                </v-btn>
                <v-btn v-else icon variant="text" size="small" color="success" @click="attiva(item)"
                    title="Riattiva azienda">
                    <v-icon>mdi-lock-open</v-icon>
                </v-btn>
            </template>
        </v-data-table>

        <v-dialog v-model="dialog" max-width="800" :fullscreen="isMobile">
            <v-card>
                <v-card-title>{{ form.id ? 'Modifica azienda' : 'Nuova azienda' }}</v-card-title>
                <v-card-text>
                    <v-form ref="formRef">
                        <div class="text-caption text-medium-emphasis font-weight-medium mb-2">Dati azienda</div>
                        <v-row>
                            <v-col cols="12" sm="8"><v-text-field v-model="form.ragioneSociale"
                                    label="Ragione sociale" :rules="[v => !!v || 'Obbligatorio']" /></v-col>
                            <v-col cols="12" sm="4"><v-text-field v-model="form.partitaIva"
                                    label="Partita IVA" /></v-col>
                        </v-row>
                        <v-text-field v-model="form.indirizzo" label="Indirizzo" />
                        <v-row>
                            <v-col cols="6"><v-text-field v-model="form.email" label="Email" /></v-col>
                            <v-col cols="6"><v-text-field v-model="form.telefono" label="Telefono" /></v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6"><v-text-field v-model="form.piano" label="Piano" /></v-col>
                            <v-col cols="6">
                                <v-text-field v-model.number="form.maxUtenti" type="number" label="Max utenti" />
                            </v-col>
                        </v-row>

                        <!-- L'utente collegato si crea solo insieme all'azienda: modificando
                             un'azienda esistente si gestisce da /aziende/:id. -->
                        <template v-if="!form.id">
                            <v-divider class="my-4" />
                            <div class="text-caption text-medium-emphasis font-weight-medium mb-2">
                                Utente collegato (un'azienda ha un solo utente)
                            </div>
                            <v-row>
                                <v-col cols="12" sm="6">
                                    <v-text-field v-model="form.username" label="Username"
                                        :rules="[v => !!v || 'Obbligatorio']" />
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-text-field v-model="form.password" type="password" label="Password provvisoria"
                                        :rules="[v => (!!v && v.length >= 8) || 'Almeno 8 caratteri']" />
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="6">
                                    <v-text-field v-model="form.displayNameUtente" label="Nome visualizzato" />
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-text-field v-model="form.eMailUtente" label="Email utente" />
                                </v-col>
                            </v-row>
                        </template>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn variant="text" @click="dialog = false">Annulla</v-btn>
                    <v-btn color="primary" @click="salva">Salva</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
export default {
    name: "AziendePage",

    data() {
        return {
            dialog: false,
            form: this.formVuoto(),
            headers: [
                { title: "Ragione sociale", key: "ragioneSociale" },
                { title: "Partita IVA", key: "partitaIva" },
                { title: "Piano", key: "piano" },
                { title: "Utente", key: "haUtente" },
                { title: "Stato", key: "attivo" },
                { title: "", key: "azioni", sortable: false },
            ],
        };
    },

    computed: {
        isMobile() {
            return this.$vuetify.display.smAndDown;
        },
        lista() {
            return this.$store.getters["aziende/lista"];
        },
    },

    mounted() {
        this.$store.dispatch("aziende/carica");
    },

    methods: {
        formVuoto() {
            return {
                id: null, ragioneSociale: "", partitaIva: "", indirizzo: "",
                email: "", telefono: "", piano: "", maxUtenti: null,
                username: "", password: "", displayNameUtente: "", eMailUtente: "",
            };
        },

        vaiDettaglio(id) {
            this.$router.push({ path: `/aziende/${id}` });
        },

        apriDialog(item) {
            this.form = item
                ? {
                    id: item.id,
                    ragioneSociale: item.ragioneSociale,
                    partitaIva: item.partitaIva,
                    indirizzo: item.indirizzo || "",
                    email: item.email,
                    telefono: item.telefono,
                    piano: item.piano,
                    maxUtenti: item.maxUtenti,
                }
                : this.formVuoto();
            this.dialog = true;
        },

        async salva() {
            if (!this.$refs.formRef.validate()) return;
            try {
                const { id, ...dati } = this.form;
                if (id) {
                    await this.$store.dispatch("aziende/aggiorna", { id, dati });
                } else {
                    await this.$store.dispatch("aziende/crea", dati);
                }
                this.dialog = false;
            } catch (error) {
                console.log(error);
            }
        },

        async attiva(item) {
            try {
                await this.$store.dispatch("aziende/attiva", item.id);
            } catch (error) {
                console.log(error);
            }
        },

        async disattiva(item) {
            try {
                await this.$store.dispatch("aziende/disattiva", item.id);
            } catch (error) {
                console.log(error);
            }
        },
    },
};
</script>
